import { render, staticRenderFns } from "./GenericConfirmModal.vue?vue&type=template&id=150ae1b6&scoped=true&lang=pug"
import script from "./GenericConfirmModal.vue?vue&type=script&lang=js"
export * from "./GenericConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./GenericConfirmModal.vue?vue&type=style&index=0&id=150ae1b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ae1b6",
  null
  
)

export default component.exports